import { render } from "./ChordComponent.vue?vue&type=template&id=1d9a7714&scoped=true"
import script from "./ChordComponent.vue?vue&type=script&lang=ts"
export * from "./ChordComponent.vue?vue&type=script&lang=ts"

import "./ChordComponent.vue?vue&type=style&index=0&id=1d9a7714&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d9a7714"

export default script